import NotificationBell from "./NotificationBell";

export default function Navbar() {
  return (
    <div className="bg-white px-6 py-4 shadow flex justify-between items-center">
      <h1 className="text-lg font-semibold">Dashboard</h1>

      <div className="flex items-center gap-4">
        <NotificationBell />
        <div className="w-8 h-8 bg-green-500 rounded-full text-white flex items-center justify-center">
          U
        </div>
      </div>
    </div>
  );
}